import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// 暂时不使用 ServiceWorker 缓存技术
import "./registerServiceWorker";
import Config from "./config";
import RjElementComponents from "rjelement-components";
import Element from "element-ui";
// import 'element-ui/lib/theme-chalk/index.css';
import "./style/theme/index.css";
import "./icons/iconfont.css"; // 阿里巴巴矢量图标
// 多语言国际化 无国际化需要 请删除
import i18n from "./i18n";
import VueCookies from "vue-cookies";
import registerDirectives from "./directives";

Vue.use(VueCookies);
Vue.use(RjElementComponents); // 会执行Rjelement的install方法，内部全部组件全局注册
Vue.config.productionTip = false;

Vue.use(Element, {
  size: Config.ElementSize,
  i18n: (key, value) => i18n.t(key, value), // 多语言国际化 无国际化需要 请删除
});

registerDirectives(Vue); // 注册指令
let APPVue = new Vue({
  router,
  store,
  i18n, // 多语言国际化, 无国际化需要 请删除
  render: (h) => h(App),
}).$mount("#app");

export default APPVue;
